import { isMobileOnly, isTablet } from "react-device-detect";

export const getDeviceType = () =>
  isMobileOnly ? "phone" : isTablet ? "tablet" : "desktop";
